module.exports = __webpack_public_path__ + "img/diagram-payment.2666b55c.png";